import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { announcementCarQueryKey } from '@autobid/ui/composables/car/data/useCurrentCarAnnouncement'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useCurrentCarAnnouncementCarFinished() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const carFinished = () => {
    startListen({
      eventName: 'premium.CAR_FINISHED',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        /*
          courier sends double finish events, one of them is invalid and it will be fixed soon,
          the invalid event has input set to "premium"
        */
        if (event.input === 'premium')
          return

        const { auctionId } = event.context

        randomDebounce(0, 2000, () => {
          const queryKey = announcementCarQueryKey.byAuctionId(auctionId)
          queryClient.invalidateQueries(queryKey)
        })
      },
    })
  }

  return { carFinished }
}
